export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_team_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'inbox_view_manage',
  'campaign_manage',
  'view_contact_phone_number',
  'kanban_manage',
  'kanban_view',
  'conversation_assign_any',
  'workspace_manage',
  'prospecting_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_team_manage',
];

// "Conversas do meu time": as dele + as do time + as dos colegas
// (Enterprise::Conversations::PermissionFilterService). É um recorte, mas maior
// que "Minhas" — por isso abre a aba Todos, que lista exatamente esse recorte.
export const CONVERSATION_TEAM_PERMISSIONS = 'conversation_team_manage';

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const INBOX_VIEW_PERMISSIONS = 'inbox_view_manage';

export const CAMPAIGN_PERMISSIONS = 'campaign_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  // A aba Todos exige a permissão de gerenciar TODAS as conversas — e só ela.
  // Antes a permissão de "conversas que participa" também abria a aba, mas no
  // backend (Enterprise::Conversations::PermissionFilterService) essa permissão
  // devolve apenas as conversas atribuídas ao próprio agente: a aba prometia
  // tudo e entregava o mesmo que "Minhas".
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_TEAM_PERMISSIONS,
    ],
  },
  // Aba separada só para grupos de WhatsApp (backend: filter_by_assignee_type
  // 'groups' + groups_count). Mantém os grupos fora das abas Minhas/Não
  // atribuídas/Todas — como o próprio WhatsApp separa.
  groups: {
    count: 'groupsCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
};
